import Vue from 'vue';
import { gsap, Quad, Power3 } from 'gsap/all';

Vue.component('chapters-map-component', {
    data() {
        return {
            drawing: '',
            number: '',
            title: '',
            address: '',
            amenities: [],
        };
    },

    mounted() {
        this.image = document.getElementById("chapters-map__image");
        this.image.onload = () => {
            this.setContainerSize();
            this.createDraggable();
        };

        this.image.src = this.image.dataset.src;
    },

    methods: {
        async createDraggable() {
            // eslint-disable-next-line
            const Draggable = await import(/* webpackChunkName: 'user' */ 'gsap/Draggable')
                .then(module => {
                    console.log(module.default);
                    return module.default
                }) // using the default export
                .catch(() => {
                    console.log('Could not load the Draggable module.');
                });

            gsap.registerPlugin(Draggable);

            Draggable.create("#chapters-map__image-container", {
                bounds: document.getElementById("chapters-map"),
            });

            EventBus.$on('window-resize', () => {
                this.setContainerSize();
            });
        },

        setContainerSize() {
            const container = document.getElementById("chapters-map__image-container");
            const image = document.getElementById("chapters-map__image");

            if (container && image) {
                const imgWidth = document.getElementById("chapters-map__image").clientWidth;
                const imgHeight = document.getElementById("chapters-map__image").clientHeight;
                container.style.height = `${imgHeight}px`;
                container.style.width = `${imgWidth}px`;
            }
        },

        mapItemEnter(index) {
            this.number = this.$attrs.chapters[index].number.url;
            this.drawing = this.$attrs.chapters[index].image.url;
            this.amenities = this.$attrs.chapters[index].amenities;
            this.title = this.$attrs.chapters[index].title;
            this.address = this.$attrs.chapters[index].address;

            const onComplete = () => {
                const elements = [...document.querySelectorAll('.chapter__amenities')];

                elements.forEach((element) => {
                    gsap.to('.chapter__amenity', { duration: 0.3, x: '0', autoAlpha: 1, ease: Power3.ease, stagger: 0.1 });
                });
            }

            gsap.to('.chapters-map__information', { duration: 0.3, y: '0', ease: Quad.easeOut, onComplete });
        },

        mapItemOut() {
            gsap.to('.chapters-map__information', { duration: 0.3, y: '100%', ease: Quad.easeOut });
        },

    },

    beforeDestroy() {
        EventBus.$off('window-resize', () => {
            this.setContainerSize();
        });
    }
});